module.exports = __webpack_public_path__ + "static/media/Resource1.028a0211.png";